<template
    ><div class="pa-5" v-if="activeShop.store">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Company name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.store.company_name ? activeShop.store.company_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Chain name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.store.chain_name ? activeShop.store.chain_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Identification code" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.store.identification_code ? activeShop.store.identification_code : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Company address" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.store.address ? activeShop.store.address : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.store.country ? getStoreCountry(activeShop.store.country) : "-" }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "store-info-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("ShopsAdminStore", ["activeShop"]),
        ...mapState(["countries"])
    },
    methods: {
        getStoreCountry(code) {
            const countryName = this.countries.find(c => c.code === code);
            if (countryName) {
                return countryName.name_et ? countryName.name_et : countryName.name_en;
            }
            return "-";
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}

.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
</style>
